import { Controller } from "@hotwired/stimulus"

// Copy a link, or open the phone's share sheet (WhatsApp, SMS…) where supported.
export default class extends Controller {
  static targets = ["toast", "label", "native"]
  static values = { url: String, text: String, copiedLabel: String }

  connect() {
    const canShare = typeof navigator.share === "function"
    this.nativeTargets.forEach((element) => { element.hidden = !canShare })
  }

  // One button that does the right thing: the phone's share sheet where there is one,
  // a copied link everywhere else.
  async share(event) {
    event.preventDefault()
    event.stopPropagation()

    const target = event.currentTarget
    const url = target.dataset.shareUrl || this.urlValue
    const text = target.dataset.shareText || this.textValue

    if (typeof navigator.share === "function") {
      try {
        await navigator.share({ title: text, text: text, url: url })
        return
      } catch (error) {
        if (error && error.name === "AbortError") return
      }
    }

    this.copy(event)
  }

  async copy(event) {
    event.preventDefault()
    event.stopPropagation()

    const url = event.currentTarget.dataset.shareUrl || this.urlValue
    try {
      await navigator.clipboard.writeText(url)
    } catch {
      const textarea = document.createElement("textarea")
      textarea.value = url
      document.body.appendChild(textarea)
      textarea.select()
      try { document.execCommand("copy") } catch {}
      document.body.removeChild(textarea)
    }

    if (this.hasLabelTarget) {
      const original = this.labelTarget.textContent
      this.labelTarget.textContent = this.copiedLabelValue || original
      setTimeout(() => { this.labelTarget.textContent = original }, 2000)
    }

    this.showToast()
  }

  async native(event) {
    event.preventDefault()
    try {
      await navigator.share({ text: this.textValue, url: this.urlValue })
    } catch {
      // Share sheet dismissed
    }
  }

  showToast() {
    if (!this.hasToastTarget) return

    this.toastTarget.classList.remove("hidden")
    setTimeout(() => this.toastTarget.classList.add("hidden"), 2500)
  }
}
